module.exports = __webpack_public_path__ + "static/BodoniSvtyTwoITCTT-Bold-15bf5b76d1144989102bf8d6c04855ca.woff";